module.exports = __webpack_public_path__ + "media/icons/home-a22ab192.svg";